<template>
  <v-container >
    <v-dialog
      v-model="paramsDialogCambio.estatus"
      persistent
      max-width="800"
    >
      <v-card v-if="alumno">
        <v-system-bar
          dark
          color="primary"
        >
          2026-08-18 / V1.2
          <v-spacer></v-spacer>
        </v-system-bar>

        <v-card-title class="text-h5">
          Solicitud: cambio de grupo
        </v-card-title>

        <v-alert
          v-if="requiereResolicitar"
          type="error"
          dense
          outlined
          class="mx-4"
        >
          No se pudo calcular el precio de este cambio. Vuelve a solicitarlo para que Finanzas pueda aceptarlo.
        </v-alert>

        <v-card-text class="black--text">

          <v-row>
            <v-col cols="12" md="6" >
              <b>Matricula:</b> {{ alumno.matricula }}
              <br/>
              <b>Nombre:</b>    {{ alumno.alumno }}
              <br/>

              <v-card outlined class="pa-2" height="65">
                <label><b>{{ alumno.grupo }}</b></label>
              </v-card>

              <v-alert
                border="left"
                color="indigo"
                outlined
                class="mt-5"
                dark
                v-if="!alumnoNoExisteGrupo"
              >
                El alumno ya no existe en este grupo o el cambio ya se ha realizado
              </v-alert>


              <v-divider></v-divider>
              <div v-if="dataGrupoActual" class="mb-10 black--text">
                <v-row>
                  <v-col cols="6" class="text-right pb-0">
                    <b>Costo curso:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    {{ dataGrupoActual.precio_grupo }}
                  </v-col>

                  <v-col cols="6" class="text-right pb-0">
                    <b>Pagado:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    {{ dataGrupoActual.pagado }}
                  </v-col>

                  <!-- <v-col cols="6" class="text-right pb-0">
                    <b>Becado:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    {{ grupoAnterior.idbecas > 0 ? 'SI' : 'NO' }}
                  </v-col> -->

                  <v-col cols="6" class="text-right pb-0" v-if="alumno.idhermanos">
                    <b>Descuento Hermanos:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0" v-if="alumno.idhermanos">
                    {{ alumno.idhermanos ? 'SI' : 'NO' }}
                  </v-col>

                  <v-col cols="6" class="text-right pb-0" v-if="esNI">
                    <b>ES NI:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0" v-if="esNI">
                    SI
                  </v-col>

                  <v-col cols="6" class="text-right pb-0" v-if="dejoVenir">
                    <b>Dejó de venir:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0" v-if="dejoVenir">
                    SI (tarifa actual)
                  </v-col>

                  <v-col cols="12">
                    <b>Concentrado de cambios</b>
                    <br/>
                    <p
                      style="white-space: pre-line"
                    >
                      {{ alumno.texto_cambio }}
                    </p>

                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="12" md="6" >
              <b>Matricula:</b> {{ alumno.matricula }}
              <br/>
              <b>Nombre:</b>    {{ alumno.alumno }}
              <br/>

              <v-card outlined class="pa-2" height="65" v-if="!checkRechazo">
                <label><b>{{ alumno.nuevo_grupo }}</b></label>
              </v-card>

              <v-progress-linear
                indeterminate
                color="cyan"
                v-if="cargar"
              ></v-progress-linear>

              <v-tooltip bottom color="blue" max-width="300" v-if="checkRechazo">
                <template v-slot:activator="{ on, attrs }">
                  <v-autocomplete
                    class="mt-2"
                    filled
                    dense
                    clearable
                    v-model="nuevoGrupo"
                    :items="grupos"
                    label="Nuevo Grupo"
                    persistent-hint
                    prepend-inner-icon="mdi-clipboard-outline"
                    return-object
                    item-text="grupo"
                    item-value="id_grupo"
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-autocomplete>
                </template>
                <span>Selecciona el nuevo grupo correcto</span>
              </v-tooltip>

              <label v-if="nuevoGrupo && checkRechazo"><b>{{ nuevoGrupo.grupo }}</b></label>
              <br/>

              <v-divider></v-divider>

              <div v-if="dataNuevoGrupo && dataGrupoActual" class="mb-10 black--text">
                <v-row>
                  <v-col cols="6" class="text-right pb-0">
                    <b>Costo curso:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    {{ costoCurso }}
                  </v-col>

                  <v-col cols="6" class="text-right pb-0">
                    <b>Pagado:</b>
                  </v-col>

                  <v-col cols="6" class="pb-0">
                    {{ dataGrupoActual.pagado }}
                  </v-col>

                  <!-- TOTAL A PAGAR -->
                  <v-col cols="6" class="text-right pb-0">
                    <b>Total a pagar:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    {{ total_a_pagar }}
                  </v-col>

                  <v-col cols="6" class="text-right pb-0" v-if="total_a_pagar > dataGrupoActual.pagado">
                    <b>Adeudo:</b>
                  </v-col>

                  <v-col cols="6" class="pb-0" v-if="total_a_pagar > dataGrupoActual.pagado">
                    {{ total_a_pagar - dataGrupoActual.pagado }}
                  </v-col>

                  <v-col cols="6" class="text-right pb-0" v-if="dataGrupoActual.pagado - total_a_pagar > 0">
                    <b>Saldo a Mover:</b>
                  </v-col>
                  <v-col cols="6" class="pb-0" v-if="dataGrupoActual.pagado - total_a_pagar > 0">
                    {{ dataGrupoActual.pagado - total_a_pagar }}
                  </v-col>

                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      v-model="precioSeleccionado2"
                      :items="precios"
                      item-text="curso"
                      item-value="id_curso"
                      filled
                      dense
                      :readonly="!checkRechazo"
                    ></v-autocomplete>
                  </v-col>


                  <b v-if="alumno.grupo_saldo || alumno.id_grupo_favor">Grupo a saldo a favor </b>

                  <span v-if="!checkRechazo">{{ alumno.grupo_saldo }}</span>

                  <v-tooltip bottom color="blue" max-width="300" v-if="( dataGrupoActual.pagado - total_a_pagar > 0 ) && checkRechazo">
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        class="mt-2"
                        filled
                        dense
                        clearable
                        v-model="id_grupo_favor"
                        :items="filterGruposSaldo"
                        label="Grupo a mandar el saldo a favor"
                        persistent-hint
                        prepend-inner-icon="mdi-clipboard-outline"
                        item-text="grupo"
                        item-value="id_grupo"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-autocomplete>
                    </template>
                    <span>Selecciona donde aplicar el saldo a favor</span>
                  </v-tooltip>

                  <v-col cols="6" class="text-right pb-0" v-if="dataGrupoActual.pagado - total_a_pagar > 0">
                    <b>Saldo a mover:</b>
                  </v-col>

                  <v-col cols="6" class="pb-0" v-if="dataGrupoActual.pagado - total_a_pagar > 0">
                    {{ dataGrupoActual.pagado - total_a_pagar }}
                  </v-col>

                  <br/>
                  <br/>
                  <p
                    style="white-space: pre-line"
                  >
                    <b>Motivo de cambio:</b> {{ alumno.motivo }}
                  </p>


                </v-row>

                <v-row>
                  <v-col cols="4" v-for="(img, i) in alumno.fotos" :key="i">
                    <v-card class="py-4 shadowCard" @click="verImagen( img.imagen )">
                      <v-img :src="url + img.imagen"  contain aspect-ratio="2"></v-img>
                    </v-card>
                  </v-col>
                </v-row>

                <div v-if="checkRechazo" class="mt-6">
                  <label>Nuevo motivo.</label>
                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-textarea
                        filled
                        dense
                        :rows="3"
                        auto-grow
                        v-model="nuevoMotivo"
                        v-bind="attrs"
                        v-on="on"
                      ></v-textarea>
                    </template>
                    <span>Describe el nuevo motivo o corrección</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-file-input 
                        small-chips 
                        multiple 
                        class="mt-4"
                        filled 
                        v-model="files" 
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Selecciona tus imagenes" prepend-icon="mdi-camera" label="Evidencias" @change="cargarFotos()"
                        v-bind="attrs"
                        v-on="on">
                      </v-file-input>
                    </template>
                    <span>Adjunta evidencias adicionales</span>
                  </v-tooltip>

                  <v-row v-if="vistaPrevias.length">
                    <v-col cols="12" md="3" v-for="(img, i) in vistaPrevias" :key="i">
                      <v-card class="py-4 shadowCard">
                        <v-img :src="img.url" contain aspect-ratio="2"></v-img>
                        <v-tooltip bottom color="blue" max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn  color="error"  small  @click="eliminarFoto(img.url)" top right absolute fab v-bind="attrs" v-on="on">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Eliminar esta imagen</span>
                        </v-tooltip>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

                <!-- Sección para rechazar o aceptar un cambio -->
                <v-row>
                  <v-col cols="12">
                    <v-card-actions class="pa-0">

                      <v-tooltip bottom color="blue" max-width="300" v-if="[3].includes( alumno.estatus ) && !esFinanzasOEsther">
                        <template v-slot:activator="{ on, attrs }">
                          <v-switch
                            v-model="checkRechazo"
                            color="black"
                            label="Rechazar"
                            v-bind="attrs"
                            v-on="on"
                          ></v-switch>
                        </template>
                        <span>Activar para rechazar esta solicitud</span>
                      </v-tooltip>

                      <v-spacer></v-spacer>

                      <v-tooltip bottom color="blue" max-width="300" v-if="!esFinanzasCambio && [2,3].includes( alumno.estatus ) && !checkRechazo ">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="green"
                            dark
                            @click="updateCambio()"
                            :loading="loading"
                            :disabled="disabled"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Aceptar
                            <v-icon small right>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span>Aceptar y procesar el cambio de grupo</span>
                      </v-tooltip>

                      <v-tooltip bottom color="blue" max-width="300" v-if="checkRechazo">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="black"
                            dark
                            @click="updateRechazo()"
                            :loading="loading"
                            :disabled="disabled"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small left>mdi-check</v-icon>
                            Enviar Rechazo
                          </v-btn>
                        </template>
                        <span>Rechazar esta solicitud con el motivo indicado</span>
                      </v-tooltip>

                    </v-card-actions>          
                  </v-col>
                </v-row>

              </div>


              <div v-if="alumno.pago_cambios">
                <v-alert
                  dense
                  outlined
                  type="error"
                >
                  Hola, Este alumno requiere de un pago de cambio de grupo
                </v-alert>
              </div>

              <div v-if="alumno.pago_cambios">
                <v-data-table
                  :headers="headersMovimientos"
                  :items="movimientos"
                  class="elevation-0 mb-4"
                  :mobile-breakpoint="100"
                  hide-default-footer
                  dense
                >
                </v-data-table>
              </div>

            </v-col>


            <!-- Grupo a grupo -->
            <v-col cols="12">
              <b>Grupos consecutivos</b>
              <br/>
              <p
                style="white-space: pre-line"
              >
                <v-alert
                  dense
                  outlined
                  border="left"
                  type="warning"
                >
                  Los grupos a continuación se verán afectados, por favor, asegurate que la información sea correcta
                </v-alert>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="gruposConsecutivos"
                >
                  <template v-slot:item.nuevo_grupo="{ item }">
                    <v-autocomplete
                      v-if="puedeSeleccionarGrupoConsecutivo()"
                      :key="'gc-' + item.id_grupo"
                      :value="grupoConsecutivoSeleccionado(item)"
                      @change="onGrupoConsecutivoChange(item, $event)"
                      :items="gruposDisponiblesConsecutivo(item)"
                      item-text="grupo"
                      return-object
                      dense
                      filled
                      hide-details
                      clearable
                      placeholder="Seleccionar grupo"
                      no-data-text="Sin grupos disponibles"
                      :menu-props="{ maxHeight: 320 }"
                    />
                    <v-chip v-else small label color="red" dark>
                      SIN GRUPO
                    </v-chip>
                  </template>
                  <template v-slot:item.pagado="{ item }">
                    {{ Number(item.pagado || 0).toFixed(2) }}
                  </template>
                  <template v-slot:item.saldo="{ item }">
                    <span :class="Number(item.saldo) < 0 ? 'red--text font-weight-bold' : ''">
                      {{ item.saldo }}
                    </span>
                  </template>
                </v-data-table>

              </p>
            </v-col>

          </v-row>
          <v-divider></v-divider>
          <br/>


          <v-checkbox
            v-if="alumno.estatus == 2"
            v-model="alumno.whatsapp"
            label="Ya se le agregó al alumno al grupo de WhatsApp"
            hide-details
          ></v-checkbox>

          <v-checkbox
            v-if="alumno.estatus == 2"
            v-model="alumno.lms"
            label="Ya se le agrego al alumno en el LMS"
            hide-details
          ></v-checkbox>

          <v-checkbox
            v-if="alumno.estatus == 2"
            v-model="alumno.zoom"
            label="Ya se le envió el codigo de zoom al alumno"
            hide-details
          ></v-checkbox>
        </v-card-text>

        <v-card-actions>

          <v-badge
            bordered
            color="error"
            icon="mdi-lock"
            overlap
            :content="alumno.historial.length"
          >
            <v-btn
              class="white--text"
              color="error"
              @click="idsolicitud_cambio = alumno.idsolicitud_cambio, paramsHistorial.estatus = true"
            >
              Historial
            <v-icon small right>mdi-file-document-multiple</v-icon>
            </v-btn>
          </v-badge>

          <v-btn
            color="black"
            small
            tile
            dark
            @click="paramsDialogCambio.estatus = false"
            absolute
            top
            right
            text
            class="mt-4"
          >
            <v-icon >mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            v-if="![4].includes( alumno.estatus ) && esFinanzasOEsther"
            class="mr-2"
            color="black"
            dark
            tile
            @click="idsolicitud_cambio = alumno.idsolicitud_cambio, paramsRechazo.estatus = true"
            small
          >
            <v-icon small left>mdi-close</v-icon>
            Rechazar
          </v-btn>

          <v-btn
            v-if="esFinanzasCambio && [1,3].includes( alumno.estatus ) "
            color="green"
            dark
            tile
            @click="addCambioFinanzas()"
            :loading="loading"
            :disabled="disabled"
            small
          >
            <v-icon small left>mdi-check</v-icon>
            Aceptar
          </v-btn>

          <v-btn
            v-if="[ 568].includes( getdatosUsuarioERPERP.iderp ) && [1,3].includes( alumno.estatus ) && estherAceptar"
            color="green"
            dark
            tile
            @click="addCambioFinanzas()"
            :loading="loading"
            :disabled="disabled"
            small
          >
            <v-icon small left>mdi-check</v-icon>
            Aceptar 
          </v-btn>

          <v-btn
            v-if="[2].includes( alumno.estatus ) "
            color="green"
            dark
            tile
            @click="updateCambio()"
            :loading="loading"
            :disabled="disabled"
            small
          >
            <v-icon small left>mdi-check</v-icon>
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ver evidencias -->
    <v-dialog v-model="dialogImagen" max-width="1000px">
      <v-card class="elevation-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogImagen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-img
            :src=" url + imagen"
            contain
            max-height="80vh"
          >
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <dialogHistorial
      v-if="paramsHistorial.estatus"
      :paramsHistorial="paramsHistorial"
      :idsolicitud_cambio="idsolicitud_cambio"
      :alumno="alumno"
    />

    <dialogRechazar
      v-if="paramsRechazo.estatus"
      :paramsRechazo="paramsRechazo"
      :idsolicitud_cambio="idsolicitud_cambio"
      @rechazado="rechazado"
    />

  </v-container>
</template>
<script>
  import axios from 'axios';
  var moment = require('moment');
  moment.locale();
  import XLSX from 'xlsx'
  import { mapGetters } from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import dialogHistorial       from '@/components/cambios/dialogHistorial.vue';
  import dialogRechazar        from '@/components/cambios/dialogRechazar.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import gruposConsecutivosMixin from '@/mixins/gruposConsecutivos'

  export default {

    components:{
      Alerta,
      carga,
      dialogHistorial,
      dialogRechazar
    },

    mixins: [ validarErrores, funcionesExcel, gruposConsecutivosMixin ],

    props: ['reporteTexto','alumno','paramsDialogCambio'],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      checkRechazo: false,
      vistaPrevias:[],
      nuevoMotivo:'',
      files: [],
      id_grupo_favor: 0,


      tipociclo:'',
      grupos:[],
      nuevoGrupo:null,
      tipocambios:[],
      tipoCambio:null,
      alumnos:[],

      dialogUpdateCambio: false,
      alumno:null,
      dialogSuccess:false,
      successMensaje:'',
      dialogRechazar:false,
      mensajeRechazo:'',
      dialogMensajes: false,
      mensajes:[],
      dialogAddCambios: false,

      teachers: [],

      grupoAlumnos:   [],
      grupoAnterior:  null,

      dialogAddCambio:false,
      loading:        false,
      disabled:       false,

      total_a_pagar: 0,
      precios:[],

      dataGrupoActual: null,
      dataNuevoGrupo:null,
      precioSeleccionado2: null,
      descuentoHermanos:0,

      url:'',

      imagen: null,
      dialogImagen: false,


      paramsHistorial: {
        estatus: false
      },

      paramsRechazo: {
        estatus: false
      },

      movimientos: [],

      alumnoNoExisteGrupo: true,


      headersMovimientos: [
        { text: 'Folio'         , value: 'id_ingreso'      },
        { text: 'Grupo'         , value: 'grupo'           },
        { text: 'Monto pagado'  , value: 'pagado'          },
      ],

      costoCurso: '',

      gruposConsecutivos:[],

      headers: [
        { text: 'Grupo '     , value: 'grupo'       },
        { text: 'Nuevo Grupo', value: 'nuevo_grupo' },
        { text: 'pagado'     , value: 'pagado'      },
        { text: 'Saldo'      , value: 'saldo'       },
      ],

      esNI: 0,
      anioMatricula: null,
      omitirRecalcWatchers: false,
      requiereResolicitar: false,
      niCursoAjustado: false,
      dejoVenir: 0,
      usarTarifaActual: 0,

    }),

    watch:{
      grupoAnterior () {
        if(this.grupoAnterior){
          this.getNuevoGrupoAlumno ()
        }else{
          this.grupos = []
        }
      },

      // Cuando se rechaza, buscamos los grupos del alumno
      checkRechazo( value ){
        if( value ){ this.getNuevoGrupoAlumno( ) }
      },

      nuevoGrupo( value ){
        if (this.omitirRecalcWatchers || !value) return
        if (this.checkRechazo) this.calcularCurso( value )
      },

      dataNuevoGrupo() {
        if (this.omitirRecalcWatchers) return
      },

      precioSeleccionado( value ){
        if( this.omitirRecalcWatchers ) return
        if( this.alumno && this.alumno.estatus > 1 ){

        }else{
          if( value && this.alumno && this.checkRechazo){ this.getPrecioPagar() }
        }
      },

      precioSeleccionado2( value ){
        if( this.omitirRecalcWatchers ) return
        if( this.alumno && this.alumno.estatus > 1 ){

        }else{
          if( value && this.alumno && this.checkRechazo){ this.getPrecioPagarFinanzas() }
        }
      },

      tipo_reporte( val ){
        if( val ){ this.step += 1 }
      },

      total_a_pagar() {
        if (this.gruposConsecutivos && this.gruposConsecutivos.length) {
          this.recalcularSaldosConsecutivos()
        }
      },
    },

    async created () {
      console.clear()

      this.url = axios.defaults.baseURL + 'evidencia-cambios/'
      
      // Cargar los cursos actuales
      await this.getCursos()

      // Ahora traemos los alumnos por escuela
      await this.initialize()

    },

    methods: {

      async initialize () {

        this.omitirRecalcWatchers = true
        this.requiereResolicitar = false
        this.niCursoAjustado = false

        try{

          this.alumnoNoExisteGrupo = true

          const response = await this.$http.post('cambios.obtener.ajuste',this.alumno)

          if( this.alumno.pago_cambios ){ this.getMovimientos( ) }

          this.dataGrupoActual = this.armarGrupoActual(response.data && response.data.grupoActual)
          this.alumnoNoExisteGrupo = !!(response.data && response.data.grupoActual) || this.alumno.estatus > 1

          this.dataNuevoGrupo = (response.data && response.data.nuevoGrupo) || this.armarNuevoGrupoDesdeSolicitud()
          this.precioSeleccionado2 = this.resolverIdCursoNuevo()

        }catch( error ){

          this.dataGrupoActual = this.armarGrupoActual(null)
          this.dataNuevoGrupo = this.armarNuevoGrupoDesdeSolicitud()
          this.precioSeleccionado2 = this.resolverIdCursoNuevo()
          const mensaje = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No fue posible cargar el detalle del cambio'
          this.validarError( mensaje )

        }

        try {
          await this.getNuevoGrupoAlumno()
        } catch (error) {
          // La lista de grupos no debe bloquear el cálculo de precio
        }

        try {
          await this.getPrecioPagarFinanzas()
        } catch (error) {
          this.marcarFallaCalculoPrecio(error)
        } finally {
          this.cargar = false
          this.$nextTick(() => { this.omitirRecalcWatchers = false })
        }

      },

      armarGrupoActual(grupoActual) {
        const base = grupoActual || {}
        const pagadoGuardado = this.alumno && this.alumno.viejo_monto
        return {
          precio_grupo: base.precio_grupo != null ? base.precio_grupo : (pagadoGuardado || 0),
          descuento: base.descuento || 0,
          precio_grupo_con_descuento_x_alumno: base.precio_grupo_con_descuento_x_alumno != null
            ? base.precio_grupo_con_descuento_x_alumno
            : (base.precio_grupo || 0),
          pagado: base.pagado != null ? base.pagado : (pagadoGuardado || 0),
          id_grupo: base.id_grupo || (this.alumno && this.alumno.id_grupo_actual),
          iva: base.iva || (this.alumno && this.alumno.iva),
        }
      },

      armarNuevoGrupoDesdeSolicitud() {
        if (!this.alumno) return null
        return {
          id_grupo: this.alumno.id_grupo_nuevo,
          grupo: this.alumno.nuevo_grupo,
          id_ciclo: this.alumno.id_ciclo,
          id_curso: this.alumno.id_nuevo_curso || this.alumno.id_curso,
        }
      },

      marcarFallaCalculoPrecio(error) {
        if (this.aplicarMontosGuardadosSolicitud()) {
          this.getGruposConsecutivos()
          return
        }
        if (this.alumno && this.alumno.estatus > 1) {
          this.requiereResolicitar = false
          return
        }
        this.requiereResolicitar = true
        const mensaje = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No se pudo calcular el precio. Vuelve a solicitar este cambio.'
        this.validarError( mensaje )
      },

      resolverIdCursoNuevo() {
        const grupoRef = (this.checkRechazo && this.nuevoGrupo) ? this.nuevoGrupo : this.dataNuevoGrupo
        const estatus = this.alumno && this.alumno.estatus
        const pendiente = !estatus || estatus == 1 || estatus == 3

        if (pendiente && this.alumnoVieneDeCursoTeens()) {
          const idTeens = this.resolverCursoPorGrupo(grupoRef)
          if (idTeens) return idTeens
        }

        if (this.alumno && this.alumno.id_nuevo_curso) {
          return Number(this.alumno.id_nuevo_curso)
        }
        return this.resolverCursoPorGrupo(grupoRef)
      },

      resolverCursoPorGrupo(value) {
        if (!value || !value.grupo || !this.alumno) {
          return this.alumno ? this.alumno.id_curso : null
        }

        const anioActual = String(new Date().getFullYear())
        let anio = String(this.alumno.matricula).substr(0, 4)
        this.anioMatricula = anio

        if (this.esNI) {
          this.anioMatricula = anioActual
        } else if (this.usarTarifaActual) {
          this.anioMatricula = anioActual
        }

        if (["2022", "2023", "2024", "2025", "2026"].includes(String(this.anioMatricula))) {
          const grupo = value.grupo
          const escuela = grupo.match('FAST') ? 2 : 1
          let cursos = (this.precios || []).filter(el => el.curso.match(this.anioMatricula))

          let cursoPredeterminado = cursos.find(curso => {
            const esOnline = curso.curso.includes('ONLINE')
            const esFast = curso.curso.includes('FAST')
            const esTeens = curso.curso.includes('TEENS')

            if (grupo.includes('ONLINE')) {
              if (escuela === 1) {
                if (this.usarTarifaTeensEnCambio(grupo)) {
                  return esOnline && !esFast && esTeens
                }
                return esOnline && !esFast && !esTeens
              }
              return esOnline && esFast
            }

            if (escuela === 1) {
              if (this.usarTarifaTeensEnCambio(grupo)) {
                return !esOnline && curso.curso.includes('INBI') && esTeens
              }
              return !esOnline && curso.curso.includes('INBI') && !esTeens
            }
            return !esOnline && esFast
          })

          return cursoPredeterminado ? cursoPredeterminado.id_curso : this.alumno.id_curso
        }

        return this.alumno.id_curso
      },

      calcularCurso( value ){
        if (!value) return
        this.precioSeleccionado2 = this.resolverCursoPorGrupo(value)
        this.getPrecioPagarFinanzas()
      },

      aplicarMontosGuardadosSolicitud() {
        const estatus = this.alumno && this.alumno.estatus
        const pendiente = !estatus || estatus == 1 || estatus == 3
        if (pendiente && this.alumnoVieneDeCursoTeens()) return false

        const totalGuardado = this.alumno && this.alumno.nuevo_monto
        if (totalGuardado == null || totalGuardado === '') return false

        this.total_a_pagar = Number(totalGuardado)
        if (this.alumno.id_nuevo_curso) {
          this.precioSeleccionado2 = Number(this.alumno.id_nuevo_curso)
        }
        const existeCosto = (this.precios || []).find(el => el.id_curso == this.precioSeleccionado2)
        this.costoCurso = existeCosto ? existeCosto.precio_lista : this.total_a_pagar
        this.requiereResolicitar = false
        return true
      },

      async getCursos ( ){
        this.cargar = true
        this.precios = []

        try{

          const response = await this.$http.get("all.precios")

          this.precios = (response.data || []).filter(el => {
            const partes = String(el.curso || '').split('-')
            return partes[1] && String(partes[1]).match('3')
          })

        }catch( error ){

          this.validarError(error);
        
        }finally{

          this.cargar = false;
        
        }

      },

      async getMovimientos ( ) {
        try{

          this.cargar = true; // iniciar el loader

          const { data } = await this.$http.get('inscripciones.alumno.grupos.activos/' + this.alumno.id_alumno);

          this.movimientos = data.filter( el => el.id_ingreso == this.alumno.id_ingreso_cambio )

        } catch (error) {

          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : (error.body && error.body.message)
          if (message) this.validarError(message);

        } finally {
          this.cargar = false;
        }
      },

      getPrecioPagar( ) {

        this.total_a_pagar = 0

        const payload = {
          escuela  : this.alumno.grupo.match('FAST') ? 2 : 1,
          id_alumno: this.alumno.id_alumno,
          id_grupo : this.alumno.id_grupo,
          id_curso : this.precioSeleccionado2,
          id_ciclo:  this.alumno.id_ciclo,
          idhermanos: this.alumno.idhermanos,

        }

        return this.$http.post('pago.grupo.nuevo.descuento', payload).then(response=>{


          if( this.precioSeleccionado2 ){

            if( this.alumno.iva ){

              this.total_a_pagar = ( response.data[0].precio_lista * 1.16 ).toFixed( 2 )

            }else{
              
              this.total_a_pagar = response.data[0].precio_lista

            }


            let existeCosto = this.precios.find( el => el.id_curso == this.precioSeleccionado2 )

            this.costoCurso = existeCosto ? existeCosto.precio_lista : 0

          }else{

            this.costoCurso = 0
            
          }

          this.cargar = false
        }).catch( error =>{

          this.requiereResolicitar = true
          this.validarError( error.response && error.response.data ? error.response.data.message : 'No se pudo calcular el precio. Vuelve a solicitar este cambio.' )
        }).finally( () => { this.cargar = false })
      },

      getPrecioPagarFinanzas( ) {

        if (!this.dataGrupoActual || !this.dataNuevoGrupo || !this.alumno) {
          this.marcarFallaCalculoPrecio()
          return Promise.resolve()
        }

        const grupoActualNombre = (this.alumno.grupo || '') + ''
        const idGrupoActual = this.dataGrupoActual.id_grupo || this.alumno.id_grupo_actual

        const payload = {
          id_alumno: this.alumno.id_alumno,
          id_grupo:  idGrupoActual,
          escuela:   grupoActualNombre.match('FAST') ? 2 : 1,
          id_curso:  this.precioSeleccionado2,
          id_ciclo:  this.dataNuevoGrupo.id_ciclo,
          idhermanos: this.alumno.idhermanos,
          alumno_ni: false
        }

        return this.$http.post('pago.grupo.nuevo.descuento', payload).then(response=>{

          if (!response.data || !response.data[0]) {
            this.marcarFallaCalculoPrecio()
            return
          }

          this.esNI = response.data[0].es_NI
          this.dejoVenir = response.data[0].dejo_venir
          this.usarTarifaActual = response.data[0].usar_tarifa_actual

          const anioActual = String(new Date().getFullYear())
          if( this.esNI && this.anioMatricula != anioActual && !this.niCursoAjustado && this.dataNuevoGrupo ){
            this.niCursoAjustado = true
            this.anioMatricula = anioActual
            this.precioSeleccionado2 = this.resolverCursoPorGrupo( this.dataNuevoGrupo )
            return this.getPrecioPagarFinanzas()
          }
          if (this.usarTarifaActual && this.anioMatricula != anioActual) {
            this.calcularCurso(this.dataNuevoGrupo || this.nuevoGrupo)
            return
          }

          const aplicaIva = !!(this.dataGrupoActual.iva || this.alumno.iva)
          const precioLista = Number(response.data[0].precio_lista) || 0

          if( aplicaIva ){

            this.total_a_pagar = Number(( precioLista * 1.16 ).toFixed( 2 ))

          }else{
            
            this.total_a_pagar = precioLista

          }

          if( this.alumno.idbecas > 0 ){

            this.total_a_pagar = Number( this.dataGrupoActual.pagado ) || 0

          }


          let existeCosto = this.precios.find( el => el.id_curso == this.precioSeleccionado2 )

          this.costoCurso = existeCosto ? existeCosto.precio_lista : 0

          this.descuentoHermanos  = response.data[0].descuentoHermanos
          this.requiereResolicitar = false

          this.getGruposConsecutivos( )

          this.cargar = false

        }).catch( error =>{
          this.marcarFallaCalculoPrecio(error)
        }).finally( () => { this.cargar = false })
      },

      getGruposConsecutivos( ){

        const payload = {
          id_alumno:   this.alumno.id_alumno,
          grupoActual: this.alumno.id_grupo_actual,
          nuevoGrupo:  this.dataNuevoGrupo,
          total_a_pagar: this.total_a_pagar,
          ...this.paramsRecalculoConsecutivos(),
        }

        return this.$http.post('grupos.consecutivos', payload).then(response=>{
          this.aplicarSaldosConsecutivosDesdeApi(response.data)
          this.cargar = false
        }).catch( error =>{
          const mensaje = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No fue posible cargar los grupos consecutivos'
          if (!String(mensaje).includes('No space left on device')) {
            this.validarError( mensaje )
          }
        }).finally( () => { this.cargar = false })
      },

      async updateRechazo( ){

        // 1-. Validar que haya un grupo seleccionado
        if( !this.nuevoGrupo ){ return this.validarErrorDirecto('Necesitas elegir un grupo por favor.') } 

        // 2-. Validar el saldo a favor
        let checkSaldo = this.dataGrupoActual.pagado - this.total_a_pagar > 0 ? true : false

        // validamos el check primero para ver que hayan seleccionado un grupo
        if( checkSaldo && !this.id_grupo_favor){ return this.validarErrorDirecto('Tienes un saldo a favor, elige elgrupo a donde se moverá dicho saldo') } 

        // Validar el motivo y evidencias
        if( !this.vistaPrevias.length ){ return this.validarErrorDirecto('Ingresa las nuevas evidencias') }

        // Validar el motivo
        if( !this.nuevoMotivo ){ return this.validarErrorDirecto('Ingresa un motivo, por favor') }

        // Validar que esten llenos los campos
        this.cargar = true
        
        let fotos = []
        if(this.vistaPrevias.length){
          let respuesta = await this.subirFotosServidor( )
          fotos = respuesta.data
        }

        // Activar el disabled del boton para que no le den doble click
        this.loading  = true
        this.disabled = true

        // Desesestructuración de alumno 
        let payload = {
          idusuario         : this.getdatosUsuarioERPERP.iderp, 
          idsolicitud_cambio: this.alumno.idsolicitud_cambio,
          comentario        : this.comentario,
          alumno            : this.alumno, 
          id_grupo_favor    : this.id_grupo_favor,
          nuevoMotivo       : this.nuevoMotivo,
          nuevoGrupo        : this.nuevoGrupo,
          fotos
        }

        this.cargar = true

        // Enviar los datos 
        this.$http.post('cambios.rechazar.final',payload).then(response=>{

          this.validarSuccess( 'Datos grabados correctamente')

          this.$emit('rechazado')

        }).catch(error=>{
          this.loading  = false
          this.disabled = false
          this.validarError( error.response.data.message )
        })

      },

      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
          // obtener la extensión del archivo
          // Hacemos la petición
          this.$http.post(`cambios.ingreso.foto`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        })
      },

      async getNuevoGrupoAlumno() {

        // Rebotarlo en caso de no seleccionar un grupo
        // if (!this.grupoAnterior) return;

        this.cargar = true; // iniciar el loader

        try {

          // Verificar la escuela
          const esFast = this.alumno.grupo && this.alumno.grupo.includes('FAST');
          const tipociclo = esFast ? `grupo LIKE '%FE%'` : `grupo NOT LIKE '%FE%'`;

          // Construir los parametros a enviar
          const payload = {
            tipociclo,
            id_ciclo: this.alumno.id_ciclo
          };

          const { data } = await this.$http.post('cambios.nuevo.grupos.ciclo', payload);

          this.cambios = data.cambios;
          this.grupos  = data.data;

          // validar si debe seleccionar un pago
          if( this.cambios ){ this.getMovimientos( ) }

        } catch (error) {

          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : (error.body && error.body.message)
          if (message) this.validarError(message)

        } finally {
          this.cargar = false;
        }

      },

      updateCambio () {
        let { whatsapp, lms, zoom, estatus } = this.alumno
        if( estatus != 2 ) {
          this.error = 'No es posible actualizar los datos ya que la solicutd aún no ah sido respondida'
          this.dialogError = true
          this.cargar = false
          return
        }

        if(whatsapp && zoom) {
          whatsapp = whatsapp ? 1 : 0
          zoom     = zoom     ? 1 : 0

          this.cargar = true

          let payload = {
            idsolicitud_cambio: this.alumno.idsolicitud_cambio,
            estatus:            4,
            lms,
            whatsapp,
            zoom,
            fecha_aceptacion:   (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            fecha_cambio:       this.alumno.fecha_cambio,
            realizo_cambio:     this.getdatosUsuarioERPERP.iderp,
          }

          this.$http.put('cambios.update/' + payload.idsolicitud_cambio,payload).then(response=>{
            this.cargar        = false
            this.successMensaje = 'Datos grabados correctamente'
            this.dialogSuccess  = true
            this.$emit('getAlumnosxEscuela')
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
          this.dialogUpdateCambio = false
        }else{
          this.error = 'Para aceptar el cambio, necesitas aceptar primero que ya el alumno está en su nuevo grupo y que ya se le envió su código de zoom'
          this.dialogError = true
          this.cargar = false
        }
      },

      rechazar () {
        let { whatsapp, lms, zoom, estatus } = this.alumno
        if( estatus != 2 ) {
          this.error = 'No es posible actualizar los datos ya que la solicutd aún no ah sido respondida'
          this.dialogError = true
          this.cargar = false
          return
        }
        this.cargar = true

        let payload = {
          idsolicitud_cambio: this.alumno.idsolicitud_cambio,
          estatus:   3,
          whatsapp:  0,
          lms:       0,
          zoom:      0
        }

        this.$http.put('cambios.update/' + payload.idsolicitud_cambio,payload).then(response=>{
          this.cargar        = false
          this.successMensaje = 'Datos grabados correctamente'
          this.dialogSuccess  = true
          this.getAlumnosxEscuela()
        }).catch(error=>{
          this.error = error.body.message
          this.dialogError = true
          this.cargar = false
        })
        this.dialogUpdateCambio = false
      },

      enviarMensaje () {
        if(this.mensajeRechazo != '' && this.mensajeRechazo != null){
          this.cargar = true
          let payload = {
            idsolicitud_cambio: this.alumno.idsolicitud_cambio,
            mensaje:            '',
            respuesta:          this.mensajeRechazo,
            envia:              0,
          }

          this.$http.post('cambios.mensaje',payload).then(response=>{
            this.dialogRechazar = false
            this.dialogMensajes = false
            this.mensajeRechazo = ''
            this.mensajes       = []
            this.rechazar()
            this.cargar = false
          }).catch(error=>{
            this.error = error.body.message
            this.dialogError = true
            this.cargar = false
            this.dialogRechazar = false
          })
        }else{
          this.error = 'Ingresa un mensaje'
          this.dialogError = true
          this.dialogRechazar = false
        }
      },

      cargarMensajes () {
        this.$http.get('cambios.mensaje/' + this.alumno.idsolicitud_cambio).then(response=>{
          this.mensajes = response.data
          this.dialogMensajes = true
          this.dialogUpdateCambio = false
          this.cargar = false
        }).catch(error=>{
          this.error = error.body.message
          this.dialogError = true
          this.cargar = false
          this.dialogRechazar = false
        })
      },

      getAhora () {
        let fecha = new Date().toLocaleString();
        fecha = moment(fecha).format().replace('T',' ').substr(0,19)
        return fecha
      },

      async addDialogCambio (alumno) {
        await this.getGrupoUsuario(alumno.id_alumno)
        this.alumno = alumno
        this.step += 1
        // this.dialogAddCambio = true
      },

      getGrupoUsuario ( idalumno ){
        this.cargar = true
        this.grupoAlumnos = []
        return this.$http.get('cambios.grupo.usuario/' + idalumno).then(response=>{
          this.grupoAlumnos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },


      addCambioFinanzas() {

        if (this.requiereResolicitar && !this.aplicarMontosGuardadosSolicitud()) {
          return this.validarErrorDirecto('No se pudo calcular el precio. Vuelve a solicitar este cambio.')
        }

        // Validar que esten llenos los campos
        if(this.alumno && this.dataGrupoActual && this.dataNuevoGrupo){

          const total = Number(this.total_a_pagar) || 0
          const pagado = Number(this.dataGrupoActual.pagado) || 0
          const saldoFavor = pagado - total
          const adeudo = total > pagado ? Number((total - pagado).toFixed(2)) : 0
          const idCurso = this.precioSeleccionado2 || this.alumno.id_nuevo_curso

          if (!idCurso) {
            return this.validarErrorDirecto('No se pudo calcular el precio. Vuelve a solicitar este cambio.')
          }

          if (saldoFavor > 0 && !this.alumno.id_grupo_favor) {
            return this.validarErrorDirecto('Hay saldo a favor pero no hay grupo destino. Vuelve a solicitar el cambio y elige el grupo.')
          }

          // Activar el disabled del boton para que no le den doble click
          this.loading  = true
          this.disabled = true
          this.overlay  = true

          // Desesestructuración de alumno
          const { id_alumno, id_plantel, monto_pagado_total, idtipo_cambio, solicito_cambio, id_grupo_actual, id_grupo_nuevo, idsolicitud_cambio } = this.alumno
          const { descuento, precio_grupo, precio_grupo_con_descuento_x_alumno } = this.dataGrupoActual

          // Generar el payload a mandar
          let payload = {
            id_alumno,
            idtipo_cambio,
            solicito_cambio,
            id_plantel,
            id_grupo:               id_grupo_actual,
            id_grupo_nuevo:         id_grupo_nuevo,
            estatus:                2,
            diferencia:             pagado,
            id_ciclo_nuevo_grupo:   this.dataNuevoGrupo.id_ciclo,
            pago_grupo_actual:      pagado,
            descuento_grupo_actual: descuento,
            precio_grupo:           precio_grupo,
            precio_descuento:       precio_grupo_con_descuento_x_alumno,
            iderp:                  this.getdatosUsuarioERPERP.iderp,

            acepto:                 this.getdatosUsuarioERPERP.iderp,
            idsolicitud_cambio,

            adeudo                    : adeudo,
            precio_grupo_con_descuento:  total,
            id_curso                  : idCurso,

            // Datos para el grupo con saldo a favor
            id_curso_2    : idCurso,
            saldo_favor   : saldoFavor > 0 ? Number(saldoFavor.toFixed(2)) : 0,
            id_grupo_saldo: saldoFavor > 0 ? this.alumno.id_grupo_favor : 0,
            total_a_pagar : total,

            // Grupos consecutivos
            gruposConsecutivos : this.gruposConsecutivos
          }


          // Enviar los datos
          this.$http.post('cambios.grupo',payload).then(response=>{
            this.validarSuccess('Cambio realizado con exito')
            // this.updatePrecioAlumno()
            this.$emit('getAlumnosxEscuela')
          }).catch( error =>{
            this.loading  = false
            this.disabled = false
            this.overlay  = false
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        }else{
          this.estatusError('Favor de ingresar el grupo y el tipo de cambio')
        }
      },

      verImagen( imagen, es_solucion ){
        this.imagen       = imagen
        this.dialogImagen = true
      },

      rechazado( ){
        this.paramsRechazo.estatus = false
        this.$emit('getAlumnosxEscuela')

      },

      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
                // creamos una variable tipo FormData
          let formData = new FormData();
                //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
                //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          this.getBase64(element, formData)
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name,
            file
          })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },
    },

    computed:{
      ...mapGetters ('login',['getdatosUsuarioERPERP']),

      idsFinanzasCambio () {
        return [28, 334, 707, 1, 1071, 2378, 2610, 954, 2910, 3042, 3264]
      },

      esFinanzasCambio () {
        return this.idsFinanzasCambio.includes( this.getdatosUsuarioERPERP.iderp )
      },

      esFinanzasOEsther () {
        return this.esFinanzasCambio || this.getdatosUsuarioERPERP.iderp == 568
      },

      estherAceptar( ){
        return this.alumno.texto_cambio.match('Horario') && !this.alumno.texto_cambio.match('Plantel') && !this.alumno.texto_cambio.match('Ciclo') && !this.alumno.texto_cambio.match('Nivel') 
      },

      filterGruposSaldo( ){

        if ( this.nuevoGrupo ){

          const { id_ciclo } = this.nuevoGrupo

          return this.grupos.filter( el => el.id_ciclo != id_ciclo )

        }else{

          return []

        }

      },
    }
  }
</script>

<style>

  .v-menu__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-menu__content::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar-button:increment,.v-menu__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-menu__content::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }
</style>
